import { buildModelManager } from "../builder.js";
const DefaultQuickQaReviewerWorkspaceSelection = {
  __typename: true,
  id: true,
  agencyBucketKey: true,
  autoReleaseAgree: true,
  autoReleaseDisagree: true,
  createdAt: true,
  metadata: true,
  originalSenderPreferences: true,
  ownerEmail: true,
  ownerId: true,
  updatedAt: true
};
const modelApiIdentifier = "quickQaReviewerWorkspace";
const pluralModelApiIdentifier = "quickQaReviewerWorkspaces";
;
;
;
;
;
const operations = [
  {
    type: "findOne",
    operationName: modelApiIdentifier,
    modelApiIdentifier,
    findByVariableName: "id",
    defaultSelection: DefaultQuickQaReviewerWorkspaceSelection,
    namespace: null
  },
  {
    type: "maybeFindOne",
    operationName: modelApiIdentifier,
    modelApiIdentifier,
    findByVariableName: "id",
    defaultSelection: DefaultQuickQaReviewerWorkspaceSelection,
    namespace: null
  },
  {
    type: "findMany",
    operationName: pluralModelApiIdentifier,
    modelApiIdentifier,
    defaultSelection: DefaultQuickQaReviewerWorkspaceSelection,
    namespace: null
  },
  {
    type: "findFirst",
    operationName: pluralModelApiIdentifier,
    modelApiIdentifier,
    defaultSelection: DefaultQuickQaReviewerWorkspaceSelection,
    namespace: null
  },
  {
    type: "maybeFindFirst",
    operationName: pluralModelApiIdentifier,
    modelApiIdentifier,
    defaultSelection: DefaultQuickQaReviewerWorkspaceSelection,
    namespace: null
  },
  {
    type: "findOne",
    operationName: pluralModelApiIdentifier,
    functionName: "findById",
    findByField: "id",
    findByVariableName: "id",
    modelApiIdentifier,
    defaultSelection: DefaultQuickQaReviewerWorkspaceSelection,
    namespace: null
  },
  {
    type: "maybeFindOne",
    operationName: pluralModelApiIdentifier,
    functionName: "maybeFindById",
    findByField: "id",
    findByVariableName: "id",
    modelApiIdentifier,
    defaultSelection: DefaultQuickQaReviewerWorkspaceSelection,
    namespace: null
  },
  {
    type: "computedView",
    operationName: "view",
    functionName: "view",
    gqlFieldName: "quickQaReviewerWorkspaceGellyView",
    namespace: null,
    variables: {
      query: { type: "String", required: true },
      args: { type: "JSONObject" }
    }
  }
];
const QuickQaReviewerWorkspaceManager = buildModelManager(
  modelApiIdentifier,
  pluralModelApiIdentifier,
  DefaultQuickQaReviewerWorkspaceSelection,
  operations
);
export {
  DefaultQuickQaReviewerWorkspaceSelection,
  QuickQaReviewerWorkspaceManager
};
//# sourceMappingURL=QuickQaReviewerWorkspace.js.map
